// extracted by mini-css-extract-plugin
export default {"wrapper":"MembersList_wrapper__k9UJY"};